import { Popover } from 'element-ui';

export default {
    name: 'HeaderAnswer',
    props: {
        id: [Number, String],
        value: String,
        label: String,
        label_class: {
            type: String,
            default: ''
        },
        hint: String,
        hint_type: { type: String, default: 'warning' },
        visible: {
            type: Boolean, default: true
        },
        smallest: { type: String, default: 'col-12' },
        small: { type: String, default: 'col-sm-12' },
        medium: { type: String, default: 'col-md-12' },
        large: { type: String, default: 'col-lg-12' },
        largest: { type: String, default: 'col-lg-12' },

    },
    components: {
        [Popover.name]: Popover,
    },
    computed: {
        column_class() {
            return `${this.largest} ${this.large} ${this.medium} ${this.small} ${this.smallest}`
        },
        label_class_value() {
            return "float-left"
        }
    },
    data() {
        return {
        };
    },
    methods: {
    },
    mounted() {
    }
};



// WEBPACK FOOTER //
// ./src/components/shared/answer-types/header/header.js